import React, { useState } from "react";
import { motion } from "framer-motion";

const Galeria = () => {
  const images = [
    "/images/Galeria/1.png",
    "/images/Galeria/2.png",
    "/images/Galeria/3.png",
    "/images/Galeria/4.png",
    "/images/Galeria/5.png",
  ];

  const [index, setIndex] = useState(0);

  const next = () => setIndex((prev) => (prev + 1) % images.length);
  const prev = () =>
    setIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div className="pt-24 pb-16 bg-[#1E0B1A] text-yellow-300">
      <div className="container mx-auto px-6">
        
        {/* TITULO */}
        <motion.section
          className="text-center py-10"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-red-400 to-yellow-400 bg-clip-text text-transparent">
            Galería
          </h2>
          <p className="text-xl text-yellow-300/80 max-w-3xl mx-auto">
            Explora imágenes especiales de nuestros rituales, energía espiritual
            y momentos mágicos.
          </p>
        </motion.section>

        {/* CARRUSEL */}
        <div className="relative max-w-3xl mx-auto">
          {/* Imagen */}
          <motion.img
            key={index}
            src={images[index]}
            className="w-full h-[350px] md:h-[450px] object-cover rounded-2xl shadow-[0_0_25px_rgba(255,0,0,0.4)] border border-red-500/40"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          />

          {/* Botón Izquierda */}
          <button
            onClick={prev}
            className="absolute top-1/2 left-4 -translate-y-1/2 bg-black/40 hover:bg-black/60 p-3 rounded-full text-yellow-300 backdrop-blur-sm"
          >
            ❮
          </button>

          {/* Botón Derecha */}
          <button
            onClick={next}
            className="absolute top-1/2 right-4 -translate-y-1/2 bg-black/40 hover:bg-black/60 p-3 rounded-full text-yellow-300 backdrop-blur-sm"
          >
            ❯
          </button>
        </div>

        {/* PUNTITOS INFERIORES */}
        <div className="flex justify-center gap-3 mt-6">
          {images.map((_, i) => (
            <motion.div
              key={i}
              onClick={() => setIndex(i)}
              className={`w-3 h-3 rounded-full cursor-pointer ${
                i === index ? "bg-red-500" : "bg-yellow-300/40"
              }`}
              whileHover={{ scale: 1.3 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Galeria;
